import * as yup from 'yup';

export const ResendFormToBillingContactValidation = yup.object().shape({
    billingContactEmailAddress: yup
        .string()
        .email('Billing contact email address is required')
        .required('Billing contact email address is required'),
    sender: yup
        .string()
        .email('Sender email address is required')
        .required('Sender email address is required'),
    coverMessage: yup
        .string()
        .required('Provide a cover message to be attached to your resend request'),
});
